import { Box, Link } from '@cloudscape-design/components';
import { useNavigate } from 'react-router';

import { Venue } from '../common/types';
import { hasPermissions } from '../common/user';
import { useContext } from 'react';
import UserContext from '../common/user';


export type MiniVenue = {
  name: string;
  uuid: string;
};

export type VenueLinkProps = {
  venue: Venue | MiniVenue;
  maxLength?: number;
};

export function VenueLink(props: VenueLinkProps) {
  const { venue } = props;
  const navigate = useNavigate();

  const { user } = useContext(UserContext);

  const canSeeVenueLink = hasPermissions(user, ['orders.get']);

  const name = venue.name.trim();

  const trimmedName = props.maxLength
    ? name.slice(0, props.maxLength) + (name.length > props.maxLength ? '...' : '')
    : name;

  if (!canSeeVenueLink) {
    return <Box variant="span">{trimmedName}</Box>;
  }

  return (
    <Link
      href={`/venues/${venue.uuid}`}
      variant="secondary"
      onFollow={(e) => {
        e.preventDefault();
        navigate(`/venues/${venue.uuid}`);
      }}
    >
      {trimmedName}
    </Link>
  );
}
